import React, { Component, useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import { AuthenticationContext } from "src/banking/AuthenticationContext";

class HideLogin extends Component {
  componentDidUpdate(prevProps) {
    // if (this.props.location !== prevProps.location) {
    //   this.props.setLoginVisible(false);
    // }
  }

  render() {
    return this.props.children;
  }
}

const HideLoginOnTransition = ({ location, children }) => {
  const authenticationContext = useContext(AuthenticationContext);

  const [currentLocation, setCurrentLocation] = useState(location);

  useEffect(
    () => {
      if (currentLocation !== location) {
        authenticationContext.setLoginVisible(false);
        setCurrentLocation(location);
      }
    },
    [currentLocation, location]
  );

  return children;
};

export default withRouter(HideLoginOnTransition);



// WEBPACK FOOTER //
// ./src/utils/HideLoginOnTransition.js